module.exports = __webpack_public_path__ + "static/media/ptv.b6d517e0.svg";